<template>
    <div class="page-content-wrapper">
      <div class="container">
        <div class="row">



          <div class="col-md-12 mb-5">
            <div class="card">
              <div class="card-block">

                <div class="ex-page-content text-center mb-5">
                  <span><i class="fa fa-thumbs-o-up icon"></i></span>
                  <h3 class="">Has completado el formulario de inscripción<br>satisfactoriamente.</h3>
                </div>

                <h5 class="card-title">Como continuar:</h5>

                <div v-if="isNewStudent()">

                  <p><strong>Para finalizar el proceso de inscripción</strong>, debes reunir los siguientes requisitos:</p>

                  <p>Imprimir la <strong>Ficha de Inscripción</strong> (la misma se encuentra debajo de estas indicaciones), haciendo click en el botón de <a class="text-primary waves-effect waves-light" href="javascript:void(0);" @click="print()"><i class="fa fa-print"></i> Imprimir</a>.</p>
                  <p>Adjuntar a la <strong>Ficha de Inscripción</strong> la siguiente documentación:<br>

                  <ul>
                  <li>Certificado de Aptitud Psicofísica otorgado UNICAMENTE por Medicina Familiar (UNNE) – Mendoza 1471.</li>
                  <li>DNI original y dos fotocopias.</li>
                  <li>Título Secundario ORIGINAL y dos fotocopias, o Constancia de Título en trámite (el mismo debe decir que "no adeuda materias").</li>
                  <li>Seis fotografías 4x4.</li>
                  <li>Partida de Nacimiento actualizada.</li>
                  <li>Certificado de Buena Conducta. Expedido por Jefatura de Policía de la Provincia. (Corrientes – Quintana 853).</li>
                  <li>Certificado de Grupo Sanguíneo y Factor</li>
                  <li>Certificado de domicilio real o transitorio, según el caso, expedido por la Policía.</li>
                  <li>Carnet de vacunación actualizado (Dos copias). – BCG, Doble Adulto (antitetánica), Doble o Triple Viral, Esquema iniciado o completo de antihepatitis B.</li>
                  <li>Una carpeta colgante forrada de color según la carrera:<br>
                    <strong>Rojo:</strong> Enfermería<br>
                    <strong>Azul:</strong> Radiología/Diagnóstico por Imágenes<br>
                    <strong>Gris:</strong> Instrumentación Quirúrgica<br>
                    <strong>Celeste:</strong> Laboratorio de Análisis Clínicos</li>
                  </ul>

                  <div style="border: 1px solid #ee8a8b; padding: 10px;" class="col-6 mb-3">
                    *Si tenés más de 25 años podes inscribirte, sin poseer título secundario.<br>
                    <small>*Ley de Educación Superior Nº 24.521</small>
                  </div>

                  <p>Toda esta documentación debes presentarla en la <strong>Secretaria del Instituto de Formación y Capacitación Cruz Roja Argentina Filial Corrientes I30 e IT11</strong>,
                    ubicado en <strong>Bolivar 1219</strong>, Corrientes, Corrientes, Argentina.</p>

                  <p>Una vez que tu inscripción haya sido verificada, vas a poder pagar la matricula desde la opción <router-link to="/list-user-payments" class="waves-effect"><i class="fa fa-money"></i> <span> Pagos </span> </router-link> en el menú de la izquierda.</p>

                </div>

                <div v-if="!isNewStudent()">

                  <p><strong>Para finalizar el proceso de inscripción</strong>, debes esperar unas horas hasta que tu inscripción sea aprobada.<br>
                    Una vez que tu inscripción haya sido verificada/aprobada, vas a poder pagar la matricula desde la opción <router-link to="/list-user-payments" class="waves-effect"><i class="fa fa-money"></i> <span> Pagos </span> </router-link> en el menú de la izquierda.<br>
                    Si ha pasado mas de un día y tu inscripción no ha sido aprobada puedes acercarte a la <strong>sala de informatica del Instituto de Formación y Capacitación Cruz Roja Argentina Filial Corrientes I30 e IT11</strong> para verificar tu situación.</p>

                </div>

                <div style="background: #ee8a8b; padding: 10px;" class="col-6 mb-3">
                  <h5 style="color: #ffffff;">Información importante:</h5>
                  <p style="color: #ffffff;">Reservaremos tu lugar como alumno una vez que hayas finalizado con todo el circuito de inscripción, el mismo finaliza con el pago de la matricula.</p>
                </div>

                <div class="text-center mt-5 mb-4">
                  <a class="btn btn-primary mb-3 waves-effect waves-light go-home" href="javascript:void(0);" @click="print()"><i class="fa fa-print"></i> Imprimir</a>
                </div>

              </div>
            </div>
          </div>



          <div class="col-md-12">
            <div id="print-container" class="card">
              <div id="print">

                <!-- Pagina 1 -->
                <div class="page" size="A4">

                  <div class="print-header row">
                    <div class="col-sm-3 pt-2 print-header-logo"><img src="../../assets/img/logo.png" height="52" alt="logo"></div>
                    <div class="col-sm-9 print-header-title">
                      <h4 v-if="configItemAcademicYear">Ficha de Inscripción - Ciclo Lectivo {{ configItemAcademicYear.value }}</h4>
                      <p>INSTITUTO DE FORMACIÓN Y CAPACITACIÓN<br>CRUZ ROJA ARGENTINA FILIAL CORRIENTES I 30 e IT 11</p>
                    </div>
                  </div>

                  <h5 class="card-title">Datos personales</h5>
                  <div class="card-text">
                    <div class="row">
                      <div class="form-group col-md-6 col-sm-6 col-6">
                        <label>Apellido</label>
                        <input type=text class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Perez" v-model="registrationForm.personalData.lastName">
                      </div>
                      <div class="form-group col-md-6 col-sm-6 col-6">
                        <label>Nombre</label>
                        <input type=text class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Juan" v-model="registrationForm.personalData.firstName">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Dni</label>
                        <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="36194445" v-model="registrationForm.personalData.dni">
                      </div>

                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Cuil</label>
                        <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="20361944454" v-model="registrationForm.personalData.cuil">
                      </div>

                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Fecha de nacimiento</label>
                        <input class="form-control"  type="date" readonly value="2011-08-19" v-model="registrationForm.personalData.birthDate">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Sexo</label>
                        <div>
                          <label v-for="gender in genders" class="custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0">
                            <input name="gender" disabled type="radio" class="form-check-input mb-2 mr-sm-2 mb-sm-0" v-bind:value="gender.value" v-model="registrationForm.personalData.gender">
                            {{ gender.text }}
                          </label>
                        </div>
                      </div>

                      <div class="form-group col-md-2 col-sm-2 col-2">
                        <label>Talla</label>
                        <select v-model="registrationForm.personalData.size" disabled class="form-control mb-2 mr-sm-2 mb-sm-0">
                          <option v-for="size in sizes" :value="size.value">{{ size.text }}</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6 col-sm-6 col-6">
                        <label>Correo electrónico</label>
                        <input type="mail" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="ejemplo@example.com" v-model="registrationForm.personalData.email">
                      </div>
                    </div>
                  </div>

                  <!--lugar de nacimiento-->
                  <h5 class="card-title">Lugar de nacimiento</h5>
                  <div class="card-text">
                    <div class="row">
                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Nacionalidad</label>
                        <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Argentina" v-model="registrationForm.personalData.birthPlace.nationality">
                      </div>
                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Provincia</label>
                        <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Corrientes" v-model="registrationForm.personalData.birthPlace.province">
                      </div>
                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Localidad</label>
                        <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Corrientes" v-model="registrationForm.personalData.birthPlace.locality">
                      </div>
                    </div>
                  </div>

                  <!--lugar de residencia actual-->
                  <h5 class="card-title">Lugar de residencia actual</h5>
                  <div class="card-text">
                    <div class="row">
                      <div class="form-group col-md-6 col-sm-6 col-6">
                        <label>Domicilio / Calle</label>
                        <input type=text class="form-control mb-2 mr-sm-2 mb-sm-0" readonly v-model="registrationForm.personalData.currentResidence.street">
                      </div>
                      <div class="form-group col-md-2 col-sm-2 col-2">
                        <label>N°</label>
                        <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly v-model="registrationForm.personalData.currentResidence.streetNumber">
                      </div>
                      <div class="form-group col-md-2 col-sm-2 col-2">
                        <label>Piso</label>
                        <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly v-model="registrationForm.personalData.currentResidence.floor">
                      </div>
                      <div class="form-group col-md-2 col-sm-2 col-2">
                        <label>Depto</label>
                        <input type=text class="form-control mb-2 mr-sm-2 mb-sm-0" readonly v-model="registrationForm.personalData.currentResidence.departamentNumber">
                      </div>
                    </div>


                    <div class="row">
                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>País</label>
                        <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Argentina" v-model="registrationForm.personalData.currentResidence.country">
                      </div>
                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Provincia</label>
                        <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Corrientes" v-model="registrationForm.personalData.currentResidence.province">
                      </div>
                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Localidad</label>
                        <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Corrientes" v-model="registrationForm.personalData.currentResidence.locality">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Barrio</label>
                        <input type=text class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Libertad" v-model="registrationForm.personalData.currentResidence.neighborhood">
                      </div>

                      <div class="form-group col-md-3 col-sm-3 col-3">
                        <label>Código Postal</label>
                        <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="3400" v-model="registrationForm.personalData.currentResidence.zipCode">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Teléfono fijo</label>
                        <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="3794123456" v-model="registrationForm.personalData.currentResidence.phone">
                      </div>

                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Celular</label>
                        <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="3794123456" v-model="registrationForm.personalData.currentResidence.cellPhone">
                      </div>

                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Compañia</label>
                        <select v-model="registrationForm.personalData.currentResidence.cellPhoneCompany" disabled class="form-control mb-2 mr-sm-2 mb-sm-0">
                          <option v-for="Company in cellPhoneCompanies" :value="Company.value">{{ Company.text }}</option>
                        </select>
                      </div>
                    </div>

                  </div>


                  <h5 class="card-title">Se inscribe en</h5>
                  <div class="card-text">
                    <div class="row">
                      <div class="form-group col-8">
                        <label>Carrera</label>
                        <input type=text class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Carrera" v-model="career.name">
                      </div>
                      <div class="form-group col-4">
                        <label>Nivel</label>
                        <input type=text class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Nivel" v-model="registrationForm.currentLevel">
                      </div>
                    </div>
                  </div>

                  <p style="page-break-before: always"></p>

              </div>

              <!-- Pagina 5 -->
              <div class="page" size="A4" v-if="isNewStudent() || (registrationToCareer && registrationToCareer.repeatingTheClass)">

                  <div class="print-header row">
                    <div class="col-sm-3 pt-2 print-header-logo"><img src="../../assets/img/logo.png" height="52" alt="logo"></div>
                    <div class="col-sm-9 print-header-title">
                      <h4 v-if="configItemAcademicYear">Ficha de Inscripción - Ciclo Lectivo {{ configItemAcademicYear.value }}</h4>
                      <p>INSTITUTO DE FORMACIÓN Y CAPACITACIÓN<br>CRUZ ROJA ARGENTINA FILIAL CORRIENTES I 30 e IT 11</p>
                    </div>
                  </div>

                  <div class="card-text">
                    <div class="row">
                      <div class="form-group col-md-6 col-sm-6 col-6">
                        <label>Apellido</label>
                        <input type=text class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Perez" v-model="registrationForm.personalData.lastName">
                      </div>
                      <div class="form-group col-md-6 col-sm-6 col-6">
                        <label>Nombre</label>
                        <input type=text class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="Juan" v-model="registrationForm.personalData.firstName">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-4 col-sm-4 col-4">
                        <label>Dni</label>
                        <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" readonly placeholder="36194445" v-model="registrationForm.personalData.dni">
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <h6>USO EXCLUSIVO DEL MÉDICO CLÍNICO:</h6>
                        <p>Teniendo a la vista las capacidades necesarias para el desarrollo de la carrera de <strong>{{ career.name }}</strong>, como su posterior ejercicio profesional,
                        obrantes en los estudios realizados y revisación clínica en el Hospital / Clínica: ........................................................................., copia de los cuales se volcaron
                        a la presente bajo mi firma, dictamino que el/la Sr/a: <strong>{{ registrationForm.personalData.lastName }} {{ registrationForm.personalData.firstName }}</strong> resulta:
                          <strong>APTO - NO APTO</strong> para ser inscripto/a en la carrera y cursar materias teóricas y prácticas presenciales intensas, con esfuerzo como alumno regular.</p>

                        <p>Fecha: ........./........./.........</p><br>

                        <p class="pull-right clearfix">................................................ <br> FIRMA - SELLO - MATRICULA</p>

                      </div>

                      <div class="col-12 mt-5">
                        <h6>USO EXCLUSICO DEL PROFESIONAL DE LA SALUD MENTAL:</h6>
                        <p>El alumno/a se encuentra en condiciones <strong>SI - NO</strong> para cursar materias teóricas y prácticas como alumno regular de la carrera.</p>

                        <p>Fecha: ........./........./.........</p><br>

                        <p class="pull-right clearfix">................................................ <br> FIRMA - SELLO - MATRICULA</p>

                      </div>

                      <div class="card-text">
                        <h6>ODONTOGRAMA:</h6>

                        <div class="row mt-5">
                          <div class="col-6">
                            <div class="col-3 tooth"></div>
                            <div class="col-1 tooth">
                              <span>18</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>17</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>16</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>15</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>14</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>13</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>12</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>11</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth"></div>
                          </div>

                          <div class="col-6">
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth">
                              <span>21</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>22</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>23</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>24</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>25</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>26</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>27</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>28</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-3 tooth"></div>
                          </div>
                        </div>

                        <div class="row mt-2">
                          <div class="col-6">
                            <div class="col-3 tooth"></div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>48</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>47</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>46</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>45</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>44</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>43</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>42</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>41</span>
                            </div>
                            <div class="col-1 tooth"></div>
                          </div>

                          <div class="col-6">
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>31</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>32</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>33</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>34</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>35</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>36</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>37</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>38</span>
                            </div>
                            <div class="col-3 tooth"></div>
                          </div>
                        </div>



                        <div class="row">
                          <div class="col-6">
                            <div class="col-3 tooth"></div>
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth">
                              <span>55</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>54</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>53</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>52</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>51</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth"></div>
                          </div>

                          <div class="col-6">
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth">
                              <span>61</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>62</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>63</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>64</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth">
                              <span>65</span>
                              <i class="fa fa-support"></i>
                            </div>
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth"></div>
                            <div class="col-3 tooth"></div>
                          </div>
                        </div>

                        <div class="row mt-2">
                          <div class="col-6">
                            <div class="col-3 tooth"></div>
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>85</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>84</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>83</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>82</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>81</span>
                            </div>
                            <div class="col-1 tooth"></div>
                          </div>

                          <div class="col-6">
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>71</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>72</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>73</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>74</span>
                            </div>
                            <div class="col-1 tooth">
                              <i class="fa fa-support"></i>
                              <span>75</span>
                            </div>
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth"></div>
                            <div class="col-1 tooth"></div>
                            <div class="col-3 tooth"></div>
                          </div>
                        </div>
                        <div class="row" style="margin-top: 70px;">
                          <div class="col-12">
                            <p class="pull-right clearfix">................................................ <br> FIRMA - SELLO - MATRICULA</p>
                          </div>
                        </div>


                        <table class="table" style="margin-top: 60px;">
                          <tr class="row mb-5">
                            <td class="col-4 text-center">FIRMA DEL ALUMNO</td>
                            <td class="col-4 text-center">ACLARACIÓN</td>
                            <td class="col-4 text-center">DNI</td>
                          </tr>

                          <tr class="row mt-5">
                            <td class="col-4 text-center">FIRMA DEL PADRE / MADRE / TUTOR<br><small>(en caso de ser menor de 18 años)</small></td>
                            <td class="col-4 text-center">ACLARACIÓN</td>
                            <td class="col-4 text-center">DNI</td>
                          </tr>
                        </table>

                      </div>


                    </div>
                  </div>

                  <p style="page-break-before: always"></p>
                </div>


            </div>
          </div>
        </div>

        <div class="controls mt-5">
          <div class="text-center form-buttons">
            <a class="btn btn-primary mb-5 waves-effect waves-light go-home" href="javascript:void(0);" @click="print()"><i class="fa fa-print"></i> Imprimir</a>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import sizes from '../../data/sizes'
import genders from '../../data/genders'
import cellPhoneCompanies from '../../data/cellPhoneCompanies'

export default {
  name: 'print-student-registration',


  created(){
    this.getAllConfigurations();
    this.getRegistrationForm();
  },


  data () {
    return {
      sizes: sizes,
      cellPhoneCompanies: cellPhoneCompanies,
      genders: genders,
      user: this.$store.state.auth.user,
    }
  },


  computed: {

    registrationForm:function(){
      return this.$store.getters.getRegistrationForm
    },

    career: function () {
      return this.$store.getters.getCareer
    },

    // traemos la configuracion para saber el año lectivo actual
    configItemAcademicYear: function () {
      return this.$store.getters.getConfigByKey('registrationToCareers.academicYear')
    },

    registrationToCareer: function () {
      return this.$store.getters.getRegistrationToCareer
    },

  },


  methods:{

    print: function () {
      var printContent = document.getElementById('print')

      document.body.appendChild(printContent)

      $("#wrapper").hide()

      window.print()

      document.getElementById('print-container').appendChild(printContent)

      $("#wrapper").show()
    },


    getRegistrationForm: function () {
      this.$store.dispatch('getRegistrationForm', { user : this.user._id })
        .then((response) => {

          if (!this.registrationForm) {
            this.$store.dispatch('cleanRegistrationForm');
          }

          this.registrationForm.personalData.birthDate = this.$moment(response.data.personalData.birthDate).add(1, 'days').format('YYYY-MM-DD');
          this.getCareer();
        })
        .catch(error => {
          console.log(error);
        })
    },


    getCareer: function () {
      if(this.registrationForm) {
        this.$store.dispatch('getCareer', {id: this.registrationForm.currentCareer})
          .then((response) => {
            this.isSaving = false
          })
          .catch(error => {
            this.error = error
            this.isSaving = false
          })
      }
    },


    getAllConfigurations: function () {

      this.$store.dispatch('getAllConfigurations')
        .then((response) => {
          this.getRegistrationToCareer();
        })
        .catch((response) => {
          this.error = response.message
        })

    },


    isNewStudent () {
      if ((this.registrationForm && this.registrationForm.currentLevel == 1)) {
        return true
      }

      return false
    },



    getRegistrationToCareer: function () {

      var self = this;

      if(self.configItemAcademicYear && self.configItemAcademicYear.value) {

        const academicYear = self.configItemAcademicYear.value;

        this.$store.dispatch('getRegistrationToCareer', { registrationToCareer: { academicYear: academicYear, user: self.user._id } })
          .then((response) => {

          })
          .catch((response) => {

          })
      }
    },

  },


  mounted(){
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

}
</script>

<style>
  .ex-page-content {
    margin-top: 40px;
  }
  .icon {
    font-size: 47px;
    margin-bottom: 10px;
  }
  .print-header {
    padding-top: 30px;
    margin-bottom: 30px;
    border-bottom: 1px solid #eeeeee;
  }
  .print-header-title {
    display: grid;
  }
  .print-header-title p {
    font-weight: 500;
  }
  #print-container {
    background: #eeeeee;
    padding: 50px;
  }
  .controls {
    width: 25cm;
    margin: 0 auto;
  }
  .tooth {
    float: left;
  }
  .tooth i {
    font-size: 25px;
  }
  .tooth span {
    font-size: 20px;
    padding: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/student_registration/PrintStudentRegistration.vue